<template>

  <div>

    <b-modal v-model="hasGeneralErrors" id="modalGeneralErrors" title="Erros encontrados:" ok-only>

      <div v-for="error in generalErrors" :key="error" class="p-2 border-bottom mb-2">
        <span class="text-danger">
          <b-icon-x-circle-fill class="mr-2"/>
          <span v-html="error.replace(/\n/g,'<br />')"></span>
        </span>
      </div>

      <template #modal-footer="{ ok }">
        <t-button @click="ok()" text="Corrigir Erros" danger/>
      </template>

    </b-modal>

    <transition mode="out-in"
                enter-active-class="animated fadeInFast">
      <b-col v-show="!busy" class="fadeIn mb-5" cols="12">

        <transition name="fade-fast">

          <div v-show="checkValidation()">

            <validation-observer ref="validationFormList" v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

              <form @submit.prevent="onSubmit" ref="formList">

                <t-form-wrapped :command="command" :status="localStatus">

                  <t-input v-model="fieldCustomizable.fieldId" hidden/>

                  <b-row style="margin-left: -5px; margin-right: -5px;" :class="{'form-loading':busyForm}">

                    <slot>

                      <b-col cols="12" class="mb-2">

                        <b-row>

                          <div class="d-flex justify-content-between col-12">

                            <b-form-checkbox v-model="fieldCustomizable.required"
                                             switch>
                              <small>Obrigatório?</small>
                              <t-help
                                  title="Caso deixar marcado este campo será de preenchimento obrigatório"/>
                            </b-form-checkbox>

                            <b-form-checkbox :disabled="fieldCustomizable.required" v-model="fieldCustomizable.fixed"
                                             switch>
                              <small>Fixado?</small>
                              <t-help
                                  title="Utilizado de forma especial para fixar o campo e não permitir alteração"/>
                            </b-form-checkbox>


                          </div>


                          <slot name="form-header"></slot>


                        </b-row>

                        <slot name="form-row-top"></slot>

                        <b-row>

                          <t-input label="Nome do Campo" cols="3" v-model="fieldCustomizable.name"
                                   :add-error="errorField.name" required/>

                          <t-input label="Observação" cols="3" v-model="fieldCustomizable.note"
                                   :small="fieldCustomizable.note !== '' ? 'Exemplo: ' + fieldCustomizable.note : ''"
                                   help="Descrição adicional aos usuários, logo abaixo do campo"/>

                          <t-input label="Ajuda" cols="3" v-model="fieldCustomizable.help"
                                   help="Texto de ajuda exibido com ícone de interrogação como este aqui de exemplo."/>

                          <t-input label="Template" cols="3" v-model="fieldCustomizable.columns"
                                   help="Exibição do campo" :options="columnOptions" select-common/>

                        </b-row>

                        <b-row>


                          <t-input cols="4" label="Tipo" help="Tipo principal do campo"
                                   v-model="fieldCustomizable.type" :add-error="errorField.type"
                                   @change="checkOptions" :options="typeOptions"
                                   required select-common/>


                          <b-col cols="3" v-show="fieldCustomizable.type === InputType.type.INPUT">
                            <t-input label="Conteúdo" v-model="fieldCustomizable.var"
                                     :options="varTypeOptions"
                                     required select-common/>

                            <b-form-checkbox v-model="fieldCustomizable.acceptZero"
                                             switch
                                             v-show="(fieldCustomizable.var === 2 || fieldCustomizable.var === 3)">
                              <small>Aceita Zero?</small>
                              <t-help
                                  title="Caso deixar marcado este campo númerico poderá receber valor zero."/>
                            </b-form-checkbox>


                          </b-col>


                          <t-input label="Precisão" help="Quantidade de casas decimais" cols="3"
                                   v-model="fieldCustomizable.decimalPrecision" :options="decimalPrecisionOptions"
                                   v-show="fieldCustomizable.type === InputType.type.INPUT && fieldCustomizable.var === 3"
                                   select-common required/>

                          <t-input label="Máscara" cols="3" v-model="fieldCustomizable.mask" :options="maskOptions"
                                   v-show="fieldCustomizable.type === InputType.type.INPUT && fieldCustomizable.var === 4"
                                   select-common/>

                          <b-col xl="6"
                                 ref="container_options"
                                 v-if="fieldCustomizable.type === InputType.type.SELECT || fieldCustomizable.type === InputType.type.RADIO || fieldCustomizable.type === InputType.type.CHECKBOX">


                            <t-input v-for="(item,index) in fieldCustomizable.options" :key="item.value"
                                     class="input-type-list-option-focus"
                                     :label="'Opção '+ (++index)" v-model="item.text" :required="index < 3"/>


                            <t-button v-show="fieldCustomizable.options.length <= 20" small outline-secondary icon-plus
                                      @click="addOption" text="Adicionar Opção"/>

                          </b-col>

                          <b-col xl="6"
                                 ref="container_options"
                                 v-if="fieldCustomizable.type === InputType.type.SELECT_COLOR">

                            <b-row v-for="(item,index) in fieldCustomizable.options" :key="item.value">

                              <t-input cols="4" :label="'Cor '+ (index+1)" v-model="item.appendage"
                                       class="input-type-list-option-focus"
                                       :required="index < 2" placeholder="#______" color-reduced/>

                              <t-input cols="8" :label="'Legenda '+ (index+1)" v-model="item.text"
                                       :required="index < 2"/>

                            </b-row>

                            <t-button v-show="fieldCustomizable.options.length <= 20" small outline-secondary icon-plus
                                      @click="addOption" text="Adicionar Cor"/>

                          </b-col>


                        </b-row>

                        <b-row>


                        </b-row>

                        <b-row class="mb-2 mt-3">

                          <b-col>
                            <t-button :primary="btnSubmitPrimary" :sending="status === 'sending'"
                                      :text="onButtonSubmitText(command) + ' Campo'" :no-icon="!btnSubmitPrimary"
                                      submit/>

                            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                              {{ t('go-back') }}
                            </b-link>
                          </b-col>


                        </b-row>

                        <slot name="form-row-bottom"></slot>


                      </b-col>

                    </slot>

                  </b-row>

                </t-form-wrapped>

              </form>

            </validation-observer>

          </div>

        </transition>

        <div v-if="orderItems && orderItems.length > 0" class="d-flex border form-list-header">

          <span style="width: 45px"></span>

          <div class="text flex-grow-1">
            <b-row>
              <b-col :cols="field.cols" v-for="field in fields.filter((a) => {return 'label' in a})" :key="field.key">
                {{ field.label }}
              </b-col>
            </b-row>
          </div>

          <span style="width: 75px"></span>

        </div>

        <div v-show="!busyList">


          <draggable :list="orderItems" @end="draggableEnd" class="list-group" handle=".handle">


            <li
                class="list-group-item list-group-item-form-list line-hover"
                v-for="(item,index) in orderItems" :key="index">

              <div class="d-flex">

                <b-icon-justify class="z-index-6 mr-2 mt-1 move handle" style="scale:1.2"/>

                <div class="text flex-grow-1 mr-3">

                  <b-row>

                    <b-col :cols="field.cols" v-for="field in fields.filter((a) => {return 'label' in a})"
                           :key="field[primaryKeyColumn]">

                        <span v-if="field.key === 'required'">
                          {{ item.fieldCustomizable.required | yesOrNot }}</span>

                      <span v-else>
                        {{ item.fieldCustomizable[field.key] }}
                        <i class="fa fa-fw text-warning ml-2"
                           v-if="field.key === 'name' && item.fieldCustomizable.typeMaster" v-b-tooltip.hover
                           title="Campo Master não poderá ser excluído, pois tem uso especial no sistema"></i>
                      </span>
                    </b-col>

                  </b-row>

                </div>

                <b-icon-pencil-square v-if="userAuth.validation.validationUpdate"
                                      @click="itemRead(item[primaryKeyColumn])"
                                      class="opacity-6-hover mt-1 mr-2 hover"
                                      style="scale:1.2"/>

                <b-icon-x-circle v-if="userAuth.validation.validationDelete && !item.fieldCustomizable.typeMaster"
                                 @click="itemDelete(item[primaryKeyColumn])"
                                 class="opacity-6-hover text-danger mt-1 hover"
                                 style="scale:1.2"/>

              </div>

            </li>


          </draggable>


        </div>

        <div class="container_loading_form" v-show="busyList">

          <div class="container_loading_form_card" style="height: 350px">

            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>
            <div class="gradient element-100" style="height: 30px; margin-top:5px"></div>

          </div>

        </div>

      </b-col>

    </transition>

    <div class="container_loading_form" v-show="busy">

      <div class="container_loading_form_card" style="height: 350px">

        <div class="gradient element-100" style="height: 30px"></div>

        <div class="gradient element-100" style="height: 100px"></div>

      </div>

    </div>


  </div>

</template>
<script>

import ui from "@/assets/scripts/ui"
import http from "@/services/config/http-common";
import VarType from "@/model/types/resource/VarType";
import InputType from "@/model/types/resource/InputType";
import FieldCustomizableEntity from "@/model/entities/resource/entity/FieldCustomizableEntity";

export default {
  name: 't-page-form-field-customizable',

  data() {
    return {
      VarType,
      InputType,
      hasGeneralErrors: false,
      drag: false,
      localStatus: "",
      type: "",
      errorList: [],
      orderItems: [],
      newOrderList: [],
      isInvalid: false,
      columnSize: 0,
      dragging: false,
      enabledDrag: false,
      fieldCustomizable: new FieldCustomizableEntity(),
      fields: [
        {key: "name", label: "Campo", cols: "5"},
        {key: "note", label: "Observações", cols: "3"},
        {key: "required", label: "Obrigatório", cols: "2"},
      ],
      columnOptions: [
        {value: 3, text: "25%"},
        {value: 4, text: "33%"},
        {value: 6, text: "50%"},
        {value: 9, text: "75%"},
        {value: 12, text: "100%"},
      ],
      typeOptions: InputType.list,
      varTypeOptions: VarType.list,
      decimalPrecisionOptions: [
        {value: 1, text: "1"},
        {value: 2, text: "2"},
        {value: 3, text: "3"},
        {value: 4, text: "4"},
      ],
      maskOptions: [
        {value: "zipcode", text: "CEP"},
        {value: "br_cpf", text: "CPF"},
        {value: "br_cnpj", text: "CNPJ"},
        {value: "email", text: "E-mail"},
        {value: "time", text: "Hora"},
        {value: "color", text: "Cores"},
        {value: "upper", text: "Texto maiúsculo"},
        {value: "lower", text: "Texto minúsculo"},
      ],


    }
  },
  props: {
    status: String,
    command: {
      type: String,
      default: 'insert'
    },
    value: {
      type: Object,
      default: null
    },
    btnSubmitPrimary: Boolean,
    errorField: Object,
    generalErrors: Array,
    title: String,
    userAuth: Object,
    items: Array,
    path: String,
    primaryKey: Number,
    foreignKey: Number,
    foreignKeyColumn: {
      type: String,
      required: true,
    },
    primaryKeyColumn: {
      type: String,
      required: true,
    },
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
    busyForm: {//busy somente do formulário na parte superior
      type: Boolean,
      default: false,
    },
    busyList: {//busy somente da listagem
      type: Boolean,
      default: false,
    }
  },
  mounted() {

    this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    this.localStatus = this.status
    this.orderItems = this.items
    this.enabledDrag = this.userAuth.validation.validationUpdate

  },
  computed: {

    onSending() {
      return this.status === "sending"
    },


  },
  methods: {

    addOption() {

      const length_old = (this.fieldCustomizable.options.length)
      const length = length_old + 1;
      this.fieldCustomizable.options.push({value: length, text: ""})

      setTimeout(() => {
        this.$refs.container_options.getElementsByClassName('input-type-list-option-focus')[length_old].getElementsByTagName('input')[0].focus()
      }, 100)

    },

    checkOptions() {

      if (((this.fieldCustomizable.type === 'R' || this.fieldCustomizable.type === 'S' || this.fieldCustomizable.type === 'SC')) && this.fieldCustomizable.options.length === 0) {

        this.fieldCustomizable.options.push({value: 1, text: "Exemplo 1"})
        this.fieldCustomizable.options.push({value: 2, text: "Exemplo 2"})
        this.fieldCustomizable.options.push({value: 3, text: "Exemplo 3"})

      }
    },

    onButtonSubmitText(command) {
      return this.t(command)
    },

    cancelUpdatedList() {
      this.$emit("onCancelUpdatedList")
    },


    draggableEnd() {

      http.post(this.path + "/changeOrder", this.orderItemsReduce()).then(() => {

        //Atualiza os indices conforme nova ordem
        ui.toast(this, "Ordem atualizada!", "Ordem alterada com sucesso")

      }).catch(async () => {
        this.$emit("onRequestList") //Enviar para o componente principal solicitar atualização de listagem
        ui.msgError(this, "Erro ao tentar atualizar a ordem das imagens. Tente novamente e caso o problema persistir informe nosso suporte técnico.");
      })

    },

    checkValidation() {
      //return ui.hasValidation(this.command,this.userAuth.validation)

      return ((this.command === 'insert' && this.userAuth.validation.validationCreate) ||
          (this.command === 'update' && this.userAuth.validation.validationUpdate) ||
          (this.command === 'delete' && this.userAuth.validation.validationDelete) ||
          (this.command === "view" && this.userAuth.validation.validationRead))

    },

    orderItemsReduce() {

      let newListOrder = []

      for (const item of this.orderItems) {
        newListOrder.push(item[this.primaryKeyColumn])
      }

      return {
        id: this.foreignKey,
        orderList: newListOrder
      }

    },

    itemRead(id) {
      this.$emit('onItemRead', id)
    },
    itemDelete(id) {

      ui.msgConfirmDelete(this, () => {
        this.$emit('onItemDelete', id)
      })

    },
    setReset() {

    },
    onSubmit() {

      //Consistências antes do envio
      if (this.fieldCustomizable.type === "T") {
        this.fieldCustomizable.var = 4
      } else if (this.fieldCustomizable.type === "R" || this.fieldCustomizable.type === "S" || this.fieldCustomizable.type === "SC") {
        this.fieldCustomizable.var = 2
      }


      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"
      this.$parent.status = "subject"

      this.$refs.validationFormList.validate().then(success => {

        if (!success) {
          ui.msgErrorForm(this, this.$refs.validationFormList)
          return;
        }

        //console.log('Form validação básica padrão passou!')

        this.$emit("input", this.fieldCustomizable)

        this.$emit('onSubmit')


      });

    },
  },
  watch: {
    status(value) {
      this.localStatus = value
    },
    items(value) {
      this.orderItems = value
    },
    userAuth(value) {
      this.enabledDrag = value.validation.validationUpdate
    },
    value(val) {
      this.fieldCustomizable = val
    },
    generalErrors() {
      this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    },
  }
}
</script>
<style scoped>
.form-list-header {
  background-color: #fafafa;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  font-weight: bold;
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.form-list-header + .list-group .list-group-item {
  border-radius: 0px;
}


.list-group-item i {
  cursor: pointer;
}


.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #0075b0 !important;
}

.list-group {
  min-height: 20px;
}


.list-group-item i {
  cursor: pointer;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}


/* 1. declare transition */
.fade-group-list-move,
.fade-group-list-enter-active,
.fade-group-list-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-group-list-enter-from,
.fade-group-list-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-group-list-leave-active {
  position: absolute;
}
</style>
